import React, { useContext } from "react";
import { FarmerContext } from "./FarmerContext";
import { Link } from "react-router-dom";
import Pagination from "../../Pagination";
import Spinner from "./../../Spinner";
export default function FarmerTransporter() {
  

  const { data, newTransportersData, farmerTransporterData, availableTransporters, formik, setRelToDel,currentPage, postsPerPage, paginate, } = useContext(FarmerContext);
  const customerTransName = availableTransporters.length > 0 ? availableTransporters.map((trans) => trans.name) : null
  // Ensure both arrays are initialized as empty arrays if not provided
  const transporters = Array.isArray(newTransportersData) ? newTransportersData : [];
  const transportersData = Array.isArray(farmerTransporterData) ? farmerTransporterData : [];
  // Determine if pagination is needed
  const shouldPaginate = transportersData.length > 4;

  // Choose which data to display
  const displayedTransporters = shouldPaginate ? transporters : transportersData;
  const handleDeleteClick=(newName)=>{
    formik.setFieldValue(newName)
    setRelToDel(true)
  }
  return (
    <div className="mt-2  mb-16">
      <div>
        <div>
          <Link to="/FarmerDash/communicate/transOwners">Communicate</Link>
        </div>
      </div>
      <div>
        {displayedTransporters.length > 0 ? (
       <div className="transporter-grid  mt-6">
       {displayedTransporters.map((transporter, index) => (
         <div key={index} className="transporter-card ">
          <form onSubmit={formik.handleSubmit} className=" ">
            <button className=" flex flex-initial bg-red-500 rounded-lg"  onClick={(e)=>handleDeleteClick(transporter?.name)} type="submit">
              DELETE
            </button>
          </form>
           <div className="transporter-container" key={index}>
             <img src={transporter.image_url} alt={transporter.name} className="transporter-image"
               onError={(e) => e.target.style.display = 'none'} />
             <div className="data-overlay" key={index}> 
               <p className="text-white italic">{transporter.name}</p>
               <p className="text-white italic">{transporter.email}</p>
               <h4 className="text-white italic">{transporter.location}</h4>
             </div>
             {/* <button className="edit-button" onClick={() => onEdit(transporter)}>EDIT</button>
             <button className="delete-button" onClick={() => onDelete(transporter)}>DELETE</button> */}
             
           </div>
         </div>
       ))}
     </div>
      ) : (
        <p>Sorry, you do not have any transporters. Want to add some?</p>
      )}
        </div>
      {shouldPaginate? <Pagination postsPerPage={postsPerPage} totalPosts={farmerTransporterData.length} currentPage={currentPage} paginate={paginate}/>:null}
      {availableTransporters.length > 0 ?
        <div>
          <form className="" onSubmit={formik.handleSubmit}>
            <label htmlFor="name">Select a transporter</label>
            <select onChange={formik.handleChange} name="name" value={formik.values.name} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline">
              <option value="">Select a transporter</option>
              {availableTransporters.map((trans, index) => (
                <option key={trans.id} value={trans.name}>{trans.name}</option>
              ))}
            </select>
            <button type="submit" onClick={(e) => { setRelToDel(false) }} className=" bg-blue-500 rounded-full disabled:opacity-50" disabled={formik.isSubmitting || !formik.isValid}>Send request</button>
          </form>
        </div> : null}
    </div>
  );
}



